module.exports = __webpack_public_path__ + "images/pages/vocal-fold/patient-3.png";